import { Component } from '@angular/core';

@Component({
    selector: 'my-profile-tooltip-person-snapshot',
    template: ` <div>Person Snapshot Component</div> `,
    styles: [``],
    standalone: false
})
export class MyProfileTooltipPersonSnapshotComponent {}
